/**
 * EDITOR モジュール
 * - .wp-wrap-post 内にある <iframe> の親 <p> 要素にクラスを付与する
 */
export const EDITOR = {
  init() {
    const containers = document.querySelectorAll('.wp-wrap-post')

    containers.forEach(container => {
      const iframes = container.querySelectorAll('iframe')

      iframes.forEach(iframe => {
        const parent = iframe.closest('p')
        if (parent) {
          parent.classList.add('c-api', 'c-api--liquid', 'c-api--editor')
        }
      })
    })
  },
}
